import React, { useState, useEffect, ReactElement, ReactNode } from 'react';
import {
  Layout,
  Menu,
  Space,
  Avatar,
  Dropdown,
  Button,
  Modal,
  MenuProps,
  Spin,
  Alert,
} from 'antd';
import {
  UserOutlined,
  MenuOutlined,
  LogoutOutlined,
  ShopOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';
//import { useMsal } from '@azure/msal-react';
//import { useAuth } from '../../auth/azureaad/authcontext';
import { useAuth } from '../../auth/authcontext';
// import { useOktaAuth } from '@okta/okta-react';
// import { useAuth } from '../../auth/okta/authcontext';
import { useGlobalLoading } from '../common/globalloadingcontext';
import LoadingMessages from '../content/loadingmessages';
import ErrorBoundary from '../common/errorboundary';

const { Header, Content, Footer } = Layout;

interface MenuItemLayoutProps {
  children: ReactElement<{ hasUnsavedChanges?: boolean; handleUnsavedChanges?: (hasChanges: boolean) => void }>;
}

const MenuItemLayout: React.FC<MenuItemLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const { globalLoading } = useGlobalLoading();
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [menuVisible, setMenuVisible] = useState(false);

  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [navigationTargetKey, setNavigationTargetKey] = useState<string | null>(null);

  // const { instance } = useMsal();
  // const { accountName } = useAuth();
  const { logout, displayName, sessionTimeRemaining, maintainSession } = useAuth();
  // const { oktaAuth } = useOktaAuth();
  // const { accountName } = useAuth();

  const handleUnsavedChanges = (hasChanges: boolean) => {
    setHasUnsavedChanges(hasChanges);
  };

  const handleOkModal = () => {
    if (navigationTargetKey) {
      navigate(navigationTargetKey);
    }
    setHasUnsavedChanges(false);
    setIsModalVisible(false);
    setNavigationTargetKey(null);
  };

  const handleCancelModal = () => {
    setIsModalVisible(false);
    setNavigationTargetKey(null);
  };

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleMenuClick: MenuProps['onClick'] = (item) => {
    if (hasUnsavedChanges) {
      setNavigationTargetKey(item.key);
      setIsModalVisible(true);
    } else {
      navigate(item.key);
      if (isMobile) {
        setMenuVisible(false);
      }
    }
  };

  const toggleMenu = () => {
    setMenuVisible(!menuVisible);
  };

  // const handleLogout = () => {
  //   instance.logout();
  // };
  const handleLogout = () => {
    logout();
  };
  // const handleLogout = () => {
  //   oktaAuth.signOut();
  // };

  // const userMenu = (
  //   <Menu onClick={handleMenuClick}>
  //     <Menu.Item key="/logout" onClick={handleLogout}>
  //       <LogoutOutlined /> Logout
  //     </Menu.Item>
  //   </Menu>
  // );

  const userMenu = (
    <Menu>
      <Menu.Item 
        key="switch-bu" 
        onClick={() => navigate('/selectbusinessunit?intent=switch')}
        icon={
          <span className="anticon" style={{ fontSize: '14px', fontWeight: 'bold' }}>
            {localStorage.getItem('BusinessUnitCode') || 'BU'}
          </span>
        }
      >
        Switch Business Unit {localStorage.getItem('BusinessUnitName') ? `(${localStorage.getItem('BusinessUnitName')})` : ''}
      </Menu.Item>
      <Menu.Item 
        key="logout" 
        onClick={handleLogout}
        icon={<LogoutOutlined />}
      >
        Logout
      </Menu.Item>
    </Menu>
  );


  const menuItems: MenuProps['items'] = [
    { key: '/', label: 'Home' },
    {
      key: '/kioskcontent',
      label: 'Kiosk Content',
      children: [
        { key: '/pageversions', label: 'Kiosk Designer' },
        { key: '/approvals', label: 'Approvals' },
        { key: '/menuitems', label: 'Menu Items' },
        { key: '/menuoptiongroup', label: 'Menu Options' },
        { key: '/addons', label: 'Add-Ons' },
      ],
    },
    {
      key: '/admin',
      label: 'Admin',
      children: [
        { key: '/stores', label: 'Stores' },
        { key: '/attractor', label: 'Attractor Loops' },
        { key: '/users', label: 'Users' },
        { key: '/roles', label: 'Roles' },
        { key: '/businessunits', label: 'Business Units' },
        { key: '/outofstock', label: 'Out of Stock' },
        { key: '/itemblock', label: 'Item Block' },
        { key: '/devices', label: 'Devices' },
        { key: '/languages', label: 'Languages' },
        { key: '/currencies', label: 'Currencies' },
        { key: '/nutrigenupclinks', label: 'Nutrigen UPC Links' },
      ],
    },
    {
      key: '/upsell',
      label: 'Upsell Management',
      children: [
        {
          key: '/upsell/forced',
          label: 'Forced Upsells'
        },
        {
          key: '/upsell/triggered',
          label: 'Triggered Upsells'
        }
      ]
    },
    {
      key: '/analytics',
      label: 'Analytics',
      children: [
        { key: '/analytics/sessions', label: 'Sessions' },
        { key: '/analytics/insights', label: 'Insights' },
        { key: '/analytics/heatmap', label: 'Heatmap' },
      ],
    }

  ];

  const menuBackgroundColor = 'var(--color-primary)';
  const headerBackgroundColor = 'var(--color-primary)';
  const footerBackgroundColor = 'var(--color-secondary)';

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header
        style={{
          padding: '0 20px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          background: headerBackgroundColor,
          boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
        }}
      >
        {isMobile && (
          <Button
            type="text"
            icon={<MenuOutlined />}
            onClick={toggleMenu}
            style={{ fontSize: '20px' }}
          />
        )}
        <div
          style={{
            fontSize: '1.8em',
            fontWeight: 600,
            color: 'white',
            fontFamily: 'sans-serif',
            marginRight: '10px',
          }}
        >
          MTO MenuBook
        </div>
        {!isMobile && (
          <Menu
            theme="dark"
            mode="horizontal"
            selectedKeys={[location.pathname]}
            onClick={handleMenuClick}
            items={menuItems}
            style={{ background: menuBackgroundColor, flex: 1 }}
            disabled={globalLoading}
          />
        )}

        {isMobile && (
          <Menu
            mode="horizontal"
            style={{
              display: menuVisible ? 'flex' : 'none',
              position: 'absolute',
              top: '64px',
              left: 0,
              width: '100%',
              background: '#fff',
              boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
              zIndex: 1000,
            }}
            selectedKeys={[location.pathname]}
            onClick={handleMenuClick}
            items={menuItems}
            disabled={globalLoading}
          />
        )}
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Dropdown overlay={userMenu}>
            <Space style={{ cursor: 'pointer', color: 'white' }}>
              <Avatar icon={<UserOutlined />} />
            {displayName || 'User'}
            {/* {accountName || 'User'} */}
            </Space>
          </Dropdown>
        </div>
      </Header>

      <Content
        style={{
          padding: '10px 52px',
          background: '#fff',
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0,
        }}
      >
        {sessionTimeRemaining !== null && (
          <Alert
            message={`You will be automatically logged out in ${Math.floor(sessionTimeRemaining / 60)}m ${sessionTimeRemaining % 60}s. Please save your work, or click the button to maintain your session.`}
            type="warning"
            banner
            action={
              <Button size="small" type="primary" onClick={async () => {
                const success = await maintainSession();
                if (!success) {
                  Modal.error({
                    title: 'Session Renewal Blocked',
                    content: 'Your browser is blocking the background session renewal (likely due to Incognito mode or strict privacy settings). Please save your work immediately, as you will be logged out when the timer expires.',
                  });
                }
              }}>
                Maintain Session
              </Button>
            }
            style={{ marginBottom: '10px' }}
          />
        )}
        <div style={{ flexGrow: 1, display: 'flex', flexDirection: 'column' }}>
          <ErrorBoundary>
            {React.cloneElement(children, { hasUnsavedChanges, handleUnsavedChanges })}
          </ErrorBoundary>
        </div>
      </Content>

      <Footer
        style={{
          textAlign: 'center',
          background: footerBackgroundColor,
          borderTop: '1px solid #e8e8e8',
          padding: '5px 0',
        }}
      >
        Designed by Team IDEA © {new Date().getFullYear()}
      </Footer>

      {globalLoading && <LoadingMessages />}

      <Modal
        title="Unsaved Changes"
        open={isModalVisible}
        onOk={handleOkModal}
        onCancel={handleCancelModal}
      >
        <p>You have unsaved changes in editor. Are you sure you want to leave?</p>
      </Modal>
    </Layout>
  );
};

export default MenuItemLayout;